import { createSelector } from 'reselect';
import get from 'lodash/get';

export const userCountryCodeSelector = (state) => get(state, 'application.setup.userCountryCode');

export const IsUserAccountEnabledSelector = createSelector(
  userCountryCodeSelector,
  (userCountryCode) => userCountryCode === 'us',
);
